publishingApp.factory('publishingHttpInterceptor', ['$rootScope', '$timeout', '$q', '$injector', '$log',

    function ($rootScope, $timeout, $q, $injector, $log) {

        $rootScope.stopRequests = false;
        var api_auth = document.querySelector('body').dataset.api_auth;
        var interceptor = {
            'request': function (request) {
                var deferred = $q.defer();
                if (request.url.indexOf("toolbar.tpl.html") == -1 && request.url.indexOf("home.html") == -1 && request.url.indexOf("footer.html") == -1) {
                    $(".page-loading").removeClass("hidden");
                }
                if ($rootScope.stopRequests) {
                    return $q.reject(request);
                } else if (request.url.indexOf($('body').attr('data-api')) != -1) {
                    request.headers = {
                        "Authorization": "Basic " + api_auth,
                        "Content-Type": "application/json",
                        "x-header-host": "oTbrPD9HRO+jdciawiXuh4vUgB8="
                    };
                    deferred.resolve(request);
                    return deferred.promise;
                } else {
                    request.headers.Authorization = "Cookie " + window.sessionId;
                    deferred.resolve(request);
                }
                return deferred.promise;
            },
            'response': function (response) {
                $(".page-loading").addClass("hidden");
                return response;
            },
            'responseError': function (reject) {
                switch (reject.status) {
                    case 500:
                        if (reject.hasOwnProperty('data')) {
                            if (reject.data.src === "sco/show/{id}") {
                                // Redirect to home if course locked
                                $rootScope.pushAlerts('Server error occurred');
                                setTimeout(function () {
                                    $injector.get('$state').go("index");
                                }, 1000);
                            }

                            else if (reject.data.hasOwnProperty('message')) {
                                $rootScope.pushAlerts(reject.data.message);
                            }

                            else if (reject.data.hasOwnProperty('error')) {
                                $rootScope.pushAlerts(reject.data.error);
                            }

                            else if (reject.data.hasOwnProperty('errors')) {
                                for (var property in reject.data.errors) {
                                    $rootScope.pushAlerts(reject.data.errors[property].toString());
                                    $log.log('500 Server Error: ' + reject.data.errors[property].toString());
                                }
                            }
                        } else {
                            $rootScope.pushAlerts('500 Server Error Occurred');
                        }

                        $(".page-loading").addClass("hidden");

                        $log.log('Server Error');
                        $log.log(reject.data);
                        return $q.reject(reject);

                    case 422:
                        if (reject.hasOwnProperty('data')) {
                             if (reject.data.hasOwnProperty('error')) {
                                $rootScope.pushAlerts(reject.data.error, true, false, null, null, null, "422_alert");
                            } else if (reject.data.hasOwnProperty('errors')) {
                                for (var property in reject.data.errors) {
                                    $rootScope.pushAlerts(reject.data.errors[property].toString());
                                    $log.log('422 Error: ' + reject.data.errors[property].toString());
                                }
                            } else if (!(reject.data.hasOwnProperty('strictErrors')
                                || reject.data.hasOwnProperty('softErrors')
                                || JSON.stringify(reject.data).indexOf("roles") !== -1
                                || JSON.stringify(reject.data).indexOf("message") !== -1
                                || JSON.stringify(reject.data).indexOf("softErrors") !== -1
                                || JSON.stringify(reject.data).indexOf("strictErrors") !== -1)) {
                                $rootScope.pushAlerts('Server Error Occurred', false, false, null, null, null, "422_alert");
                            }
                            else if (reject.data.hasOwnProperty('message')) {
                                $rootScope.pushAlerts(reject.data.message);
                            }
                        } else {
                            $rootScope.pushAlerts('422 Server Error Occurred');
                        }

                        $(".page-loading").addClass("hidden");

                        $log.log('Server Error');
                        $log.log(reject.data);
                        return $q.reject(reject);

                    case 401:
                        $rootScope.pushAlerts('Sorry, your session had expired. Please log in again', false, false, 'icon-info-circle', null, null, "401_alert");
                        setTimeout(function () {
                            window.location.href = '/logout';
                        }, 1500);

                        $(".page-loading").addClass("hidden");
                        $log.log(reject.data);
                        return $q.reject(reject);

                    case 403:
                        if (reject.data.message === "This action is unauthorized." && reject.config.url.indexOf('/tree-phase-one/') !== -1) {
                            // Redirect to home if course locked
                            $rootScope.pushAlerts('This action is unauthorized', null, null, null, null, null, "403_alert");
                            setTimeout(function () {
                                $injector.get('$state').go("index");
                            }, 1000);
                        } else {
                            $rootScope.pushAlerts('403 Server Error Occurred', null, null, null, null, null, "403_alert");

                            if (reject.data.message) {
                                $rootScope.pushAlerts(reject.data.message);
                                $log.log('403 Server Error message: ' + reject.data.message + '. End of critical error.');
                                $('.page-loading').hide();
                            }

                            // Inject redirect if user suspended
                            if (reject.data.desc === "user-suspended") {
                                $injector.get('$state').go("no-permission");
                                $rootScope.pushAlerts('Sorry, you have no permission to be here', false, false, 'icon-error-strict');
                                // So tempted to put "Nothing to see here" //
                                $log.log(reject.status + ' Server Error message: ' + reject.data.desc + '. End of critical error.');
                            }
                        }

                        return $q.reject(reject);

                    case 404:
                        if (reject.config.url.indexOf('/reviews') !== -1) {
                            console.warn('[[404 review does not exist for this entity]]');
                        } else {
                            if (reject.hasOwnProperty('data')) {
                                if (reject.data.hasOwnProperty('error')) {
                                    $rootScope.pushAlerts(reject.data.error);
                                }

                                if (reject.data.hasOwnProperty('errors')) {
                                    for (var property in reject.data.errors) {
                                        $rootScope.pushAlerts(reject.data.errors[property].toString());
                                        $log.log('404 Error: ' + reject.data.errors[property].toString());
                                    }
                                }
                            } else {
                                $rootScope.pushAlerts('404 Error, the resources cannot be found.');
                                $log.log('404 on ' + reject.config.url);
                            }
                        }

                        $(".page-loading").addClass("hidden");

                        return $q.reject(reject);

                    default:
                        var message = (typeof reject.status !== "undefined") ? reject.status + ' Error Occurred, please see console for more details.' : 'An Error Occurred, please see console for more details.';
                        $rootScope.pushAlerts(message);

                        $(".page-loading").addClass("hidden");

                        $log.log('Server Error');
                        $log.log(reject.data);

                        return $q.reject(reject);
                }
            }
        };

        return interceptor;
    }]);